import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "content-list",
  name: "国学内容",
  icon: "文",
  group: "国学组件",
  description: "展示国学文章、节气、黄历宜忌和短视频内容。",
  defaultProps: {
    "title": "国学内容",
    "limit": 4
}
}
